import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import useScrollReveal from "@/hooks/useScrollReveal";
import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { Manifesto } from "@/components/Manifesto";
import { Collection } from "@/components/Collection";
import { Testimonials } from "@/components/Testimonials";
import { Waitlist } from "@/components/Waitlist";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

const Home = () => {
  useScrollReveal();
  return (
    <main data-testid="home-page" className="relative">
      <Navigation />
      <Hero />
      <Manifesto />
      <Collection />
      <Testimonials />
      <Waitlist />
      <Footer />
      <WhatsAppFloat />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#15302A",
            color: "#F5F0E8",
            border: "1px solid rgba(212,175,106,0.3)",
            borderRadius: 0,
            fontFamily: "DM Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
